'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var FaresOptimizerDataTransformerService = function FaresOptimizerDataTransformerService($q, $filter, momentService, restangular, configurationService, dataUtilsService, faresOptimizerConstants, entryLevelBenchmarkDataTransformerService, selectedComparisonDataTransformerService) {
  function getCompetitors(recommendation, recommendationLadder) {
    var competitor;
    var isLinkedFbc = recommendation.sponsorMarketFbc !== undefined;
    var isEntryLevel = recommendationLadder.hostEntryLevelFbc === recommendation.fareBasisCode && !isLinkedFbc;
    competitor = _.find(recommendationLadder.competitorFares, {
      'competitorKey': recommendation.selectedCompetitorKey
    });
    if (!competitor && isEntryLevel) {
      competitor = _.find(recommendationLadder.competitorFares, {
        'isActive': true
      });
    }
    var fareBrandInfo;
    if (competitor) {
      fareBrandInfo = dataUtilsService.getFareBrandInfo(competitor.carrier, competitor.fareBrand);
    }
    return competitor ? {
      compFareSource: competitor.fareSource,
      compCarrier: competitor.carrier,
      compTariffNumber: competitor.tariffCode,
      compMarketFbc: recommendationLadder.origin + recommendationLadder.destination === competitor.origin + competitor.destination ? competitor.fareBasisCode : competitor.fareBasisCode + '\n(' + competitor.origin + '-' + competitor.destination + ')',
      compFare: competitor.currencyCode + '&nbsp;' + Math.round(competitor.totalFare),
      compRoutingNumber: competitor.routingNumber,
      compFootnote: competitor.footnote,
      compTripType: faresOptimizerConstants.FARE_TYPES[competitor.tripType],
      compFareBrandName: fareBrandInfo.fareBrandName,
      compFareBrand: fareBrandInfo.fareBrand,
      normalizedTotalFare: competitor.normalizedTotalFare,
      compBaseFare: competitor.baseFare,
      compVariable: competitor.variable,
      compYq: competitor.yq,
      compYr: competitor.yr,
      compQ: competitor.q,
      compSixH: competitor.sixH,
      compSixI: competitor.sixI,
      compSixJ: competitor.sixJ,
      compSixK: competitor.sixK,
      compAirportTax: competitor.other,
      compQMisc: competitor.qmisc,
      compAp: competitor.advancePurchase,
      isMappedRbd: !_.isNil(recommendation.selectedCompetitorKey) && recommendation.selectedCompetitorKey === getKey(competitor) && recommendation.actionCode !== 'X'
    } : {};
  }
  function getFiledFareTaxes(recommendation) {
    if (!recommendation.filedFareTaxDetails) {
      return {};
    }
    return {
      yq: recommendation.filedFareTaxDetails.yq,
      yr: recommendation.filedFareTaxDetails.yr,
      other: recommendation.filedFareTaxDetails.other,
      q: recommendation.filedFareTaxDetails.q,
      variable: recommendation.filedFareTaxDetails.variable,
      qmisc: recommendation.filedFareTaxDetails.qMisc
    };
  }
  function getOfferTaxes(recommendation, recommendationLadder) {
    if (!recommendation.offerTaxDetails) {
      return {};
    }
    return {
      offerYq: recommendation.offerTaxDetails.yq,
      offerYr: recommendation.offerTaxDetails.yr,
      offerOther: recommendation.offerTaxDetails.other,
      offerQ: recommendation.offerTaxDetails.q,
      offerVariable: recommendation.offerTaxDetails.variable,
      offerQmisc: recommendation.offerTaxDetails.qMisc
    };
  }
  function getCurrentFareTaxes(recommendation) {
    if (!recommendation.currentFareTaxDetails) {
      return {};
    }
    return {
      currentFareYq: recommendation.currentFareTaxDetails.yq,
      currentFareYr: recommendation.currentFareTaxDetails.yr,
      currentFareOther: recommendation.currentFareTaxDetails.other,
      currentFareQ: recommendation.currentFareTaxDetails.q,
      currentFareVariable: recommendation.currentFareTaxDetails.variable,
      currentFareQmisc: recommendation.currentFareTaxDetails.qMisc
    };
  }
  function getKey(ladder) {
    return [ladder.carrier, ladder.origin, ladder.destination, ladder.fareBasisCode, ladder.routingNumber, ladder.tariffCode, ladder.footnote].filter(Boolean).join('-');
  }
  function populateKeyForCompetitor(recommendationLadder) {
    _.forEach(recommendationLadder.competitorFares, function (entry) {
      entry.competitorKey = getKey(entry);
    });
  }
  function updateDatesFromUserAdjustments(recommendation, recommendationLadder) {
    if (isNotUpperBound(recommendation.fareBasisCode, recommendationLadder.hostHighestFbc) && !isUserAdjustmentUndefined(recommendation)) {
      recommendation.firstTicketDate = undefined;
      recommendation.lastTicketDate = undefined;
      recommendation.travelFromDate = undefined;
      recommendation.travelToDate = undefined;
      recommendation.travelCompleteDate = undefined;
      if (!isUserAdjustedDatesNullOrUndefined(recommendation, 'ticketingDates')) {
        recommendation.firstTicketDate = getEarliestDate(recommendation, 'ticketingDates', 'begin');
        recommendation.lastTicketDate = getLatestDate(recommendation, 'ticketingDates', 'end');
      }
      if (!isUserAdjustedDatesNullOrUndefined(recommendation, 'outboundTravelDates')) {
        recommendation.travelFromDate = getEarliestDate(recommendation, 'outboundTravelDates', 'from');
        recommendation.travelToDate = getLatestDate(recommendation, 'outboundTravelDates', 'to');
        recommendation.travelCompleteDate = getLatestDate(recommendation, 'outboundTravelDates', 'complete');
      }
    }
  }
  function getAutoApprovalStoppedMessageDetails(ladderRemarks) {
    if (_.isEmpty(ladderRemarks) || _.isEmpty(ladderRemarks.dataComparisonReasons)) {
      return ['Nil'];
    }
    var autoApprovalStoppedReasons = _.chain(getDataComparisonReasons(ladderRemarks.dataComparisonReasons)).map('shortRemark').uniq().compact().value();
    return _.isEmpty(autoApprovalStoppedReasons) ? ['Nil'] : autoApprovalStoppedReasons;
  }
  function buildEntry(recommendation, recommendationLadder, isFound, index) {
    var fareChangePercent = !_.isNil(recommendation.fareChange) && recommendation.fareChange === 0 ? 0 : undefined;
    if (!_.isNil(recommendation.fareChange) && recommendation.fareChange !== 0) {
      fareChangePercent = recommendation.fareChange / recommendation.baseFare;
    }
    var recommendationActionCodes = dataUtilsService.getRecommendationActionCodes(recommendationLadder);
    var minStaysList = dataUtilsService.getMinStaysList(recommendationLadder);
    var maxStayList = dataUtilsService.getMaxStayList(recommendationLadder);
    var outboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(recommendation.outboundDaysOfWeek);
    var inboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(recommendation.inboundDaysOfWeek);
    var season = getSeasonData(recommendationLadder, recommendation);
    var isLinkedFbc = recommendation.sponsorMarketFbc !== undefined;
    var isDualRbdFare = recommendation.dualRbdSponsorFbc !== undefined;
    var isEntryLevel = false;
    var groupingStartRow = false;
    var initialRow = index === 0;
    if (!isFound.entryLevel) {
      isEntryLevel = recommendationLadder.hostEntryLevelFbc === recommendation.fareBasisCode && !isLinkedFbc;
      isFound.entryLevel = isEntryLevel;
    }
    if (!isFound.startRow) {
      groupingStartRow = _.first(recommendationLadder.fareRecommendationList).fareBasisCode === recommendation.fareBasisCode && !isLinkedFbc;
      isFound.startRow = groupingStartRow;
    }
    var hasLinkedFbc = isLinkedFbc ? false : dataUtilsService.isSponsorMarketFbc(recommendationLadder, recommendation);
    var fareBrandInfo = dataUtilsService.getFareBrandInfo(recommendation.carrier, recommendation.fareBrand);
    updateDatesFromUserAdjustments(recommendation, recommendationLadder);
    var newEntry = {
      market: isEntryLevel ? getMarket(recommendationLadder) : getMarket(recommendation),
      origin: recommendation.origin,
      destination: recommendation.destination,
      cabin: recommendation.cabinCode,
      carrier: recommendation.carrier,
      footnote: recommendation.footnote,
      tariffCode: recommendation.tariffCode,
      tariffNumber: recommendation.tariffCode,
      routingNumber: recommendation.routingNumber,
      season: replaceNullOrHyphenValue(season),
      pos: recommendationLadder.pos,
      marketTier: recommendationLadder.marketTier,
      dow: outboundDaysOfWeek,
      inboundDow: inboundDaysOfWeek,
      rbd: recommendation.rbd,
      fbc: getResolvedFbc(isLinkedFbc, isDualRbdFare, recommendation, recommendationLadder),
      alignedWith: recommendationLadder.alignedWith,
      isEntryLevel: isEntryLevel,
      groupingStartRow: groupingStartRow,
      hasLinkedFbc: hasLinkedFbc,
      isLinkedFbc: isLinkedFbc,
      isDualRbdFare: isDualRbdFare,
      eventTimeStamp: recommendationLadder.eventTimeStamp,
      approvalDateTime: recommendationLadder.approvalDateTime,
      lastUpdated: convertToLocalDateTime(recommendationLadder.eventTimeStamp),
      isExpired: recommendationLadder.isExpired,
      createdAt: recommendationLadder.createdAt,
      lastUpdatedBy: recommendationLadder.lastUpdatedBy,
      effectiveDate: momentService.of(recommendation.effectiveDate, momentService.FIELD.DEPARTURE_DATE),
      discontinueDate: momentService.of(recommendation.discontinueDate, momentService.FIELD.DEPARTURE_DATE),
      outboundSeasons: recommendation.outboundSeasons,
      outboundBlackouts: recommendation.outboundBlackouts,
      inboundSeasons: recommendation.inboundSeasons,
      inboundBlackouts: recommendation.inboundBlackouts,
      reservationDates: recommendation.reservationDates,
      ticketingDates: recommendation.ticketingDates,
      inboundTravelDates: recommendation.inboundTravelDates,
      outboundTravelDates: recommendation.outboundTravelDates,
      travelFromDate: momentService.of(recommendation.travelFromDate, momentService.FIELD.DEPARTURE_DATE),
      travelToDate: momentService.of(recommendation.travelToDate, momentService.FIELD.DEPARTURE_DATE),
      travelCompleteDate: momentService.of(recommendation.travelCompleteDate, momentService.FIELD.DEPARTURE_DATE),
      firstTicketDate: momentService.of(recommendation.firstTicketDate, momentService.FIELD.DEPARTURE_DATE),
      lastTicketDate: momentService.of(recommendation.lastTicketDate, momentService.FIELD.DEPARTURE_DATE),
      matchPercentage: recommendation.matchPercentage === undefined ? 0 : recommendation.matchPercentage,
      constructionMethod: recommendation.constructionMethod,
      minStays: recommendation.minStays,
      maxStay: recommendation.maxStay,
      advancePurchase: recommendation.advancePurchase,
      category: recommendationLadder.category,
      ap: replaceNullOrHyphenValue(recommendation.advancePurchase),
      mms: replaceNullOrHyphenValue(recommendation.minStays) + ' - ' + replaceNullOrHyphenValue(recommendation.maxStay),
      apGroup: replaceNullOrHyphenValue(recommendation.advancePurchaseGroup),
      mmsGroup: [replaceNullOrHyphenValue(recommendation.minStayGroup), replaceNullOrHyphenValue(recommendation.maxStayGroup)].join('/'),
      minStayGroup: replaceNullOrHyphenValue(recommendation.minStayGroup),
      maxStayGroup: replaceNullOrHyphenValue(recommendation.maxStayGroup),
      currencyCode: recommendation.currencyCode,
      currentFareTotal: recommendation.totalFare,
      recommendedFareTotal: recommendation.recommendedTotalFare,
      currentFareBase: recommendation.baseFare,
      recommendedFareBase: recommendation.recommendedBaseFare,
      effectiveBaseFare: recommendation.effectiveBaseFare,
      distributedFare: recommendation.distributedFare,
      effectiveTotalFare: recommendation.effectiveTotalFare,
      fareChangeAbsolute: recommendation.fareChange,
      fareChangePercentage: fareChangePercent,
      effectiveFareChangeAbsolute: recommendation.effectiveFareChange,
      status: recommendationLadder.status,
      remarks: recommendationLadder.remarks,
      fareFamily: recommendation.fareBasisCode.substring(1),
      fareRecommendationRecordKey: recommendationLadder.fareRecommendationRecordKey,
      yq: recommendation.yq,
      sixH: recommendation.sixH,
      sixI: recommendation.sixI,
      sixJ: recommendation.sixJ,
      sixK: recommendation.sixK,
      yr: recommendation.yr,
      q: recommendation.q,
      airportTax: recommendation.other,
      variable: recommendation.variable,
      recommendedVariable: computeVariableTaxUsingBaseFare(recommendation.yq, recommendation.yr, recommendation.recommendedBaseFare, recommendation.variableTaxPercentage),
      effectiveVariable: recommendation.recommendedVariable,
      variableTaxPercentage: recommendation.variableTaxPercentage,
      qMisc: recommendation.qmisc,
      authorizationNotes: recommendationLadder.authorizationNotes,
      minFareThreshold: recommendation.minFareThreshold,
      maxFareThreshold: recommendation.maxFareThreshold,
      benchmarkFareComponent: recommendation.benchmarkFareComponent,
      recommendationEffectiveDate: momentService.of(recommendationLadder.recommendationEffectiveDate, momentService.FIELD.DEPARTURE_DATE),
      sponsorMarketFbc: recommendation.sponsorMarketFbc,
      dualRbdSponsorFbc: recommendation.dualRbdSponsorFbc,
      percentageLinkageFactor: recommendation.percentageLinkageFactor,
      useForLadderGenerationInd: _.isNil(recommendation.useForLadderGenerationInd) ? null : recommendation.useForLadderGenerationInd,
      absoluteLinkageFactor: recommendation.absoluteLinkageFactor,
      isSharedFbc: isSharedFbc(recommendation),
      sharedEntryLevelFbcList: extractSharedFbcList(recommendation),
      sharedFbcLadderIds: getSharedFBCLadderIds(recommendation),
      linkedFbcs: hasLinkedFbc ? dataUtilsService.getLinkedFbc(recommendationLadder, recommendation) : [],
      rejectionExpiryDateTime: recommendationLadder.rejectionExpiryDateTime,
      tripType: faresOptimizerConstants.FARE_TYPES[recommendation.tripType],
      fareBrand: fareBrandInfo.fareBrand,
      fareBrandName: fareBrandInfo.fareBrandName,
      actionCode: recommendation.actionCode,
      recommendationActionCodes: recommendationActionCodes,
      minStaysList: minStaysList,
      maxStayList: maxStayList,
      selectedCompetitorKey: recommendation.selectedCompetitorKey,
      isMappedRbd: !!(recommendation.selectedCompetitorKey && recommendation.actionCode !== 'X'),
      userAdjustedDates: recommendation.userAdjustedDates,
      businessRule: getBusinessRule(recommendationLadder.businessRule, recommendation.businessRule, isEntryLevel),
      seasonIndicator: recommendationLadder.seasonIndicator,
      seasonMatchThreshold: recommendationLadder.seasonMatchThreshold,
      hostEntryLevelFbc: recommendationLadder.hostEntryLevelFbc,
      hostHighestFbc: recommendationLadder.hostHighestFbc,
      ladderRemarks: recommendationLadder.ladderRemarks,
      autoApprovalStoppedReasonsFilterKeys: getAutoApprovalStoppedMessageDetails(recommendationLadder.ladderRemarks),
      rbdMethod: recommendationLadder.rbdMethod,
      isSystemGeneratedLadder: recommendationLadder.isSystemGeneratedLadder,
      isShowRecommendationId: true,
      ladderMethod: getLadderMethod(recommendationLadder),
      isCat2Updated: recommendationLadder.isCat2Updated,
      isFootnoteUpdated: recommendationLadder.isFootnoteUpdated,
      isRuleUpdated: recommendationLadder.isRuleUpdated,
      isAlignSaveAdjustmentEnabled: recommendationLadder.inventoryAssignmentMethod === faresOptimizerConstants.RBD_METHOD.RBD_TO_RBD,
      isAdvancePurchaseUpdated: recommendationLadder.isAdvancePurchaseUpdated,
      isAutoApprovable: initialRow ? recommendationLadder.isAutoApprovable : recommendation.isAutoApprovable,
      isRecommendationCapped: recommendation.isRecommendationCapped === true,
      discontinuedRuleSequence: _.isNil(recommendation.discontinuedRuleSequence) ? null : recommendation.discontinuedRuleSequence,
      isDiscontinueRule: !_.isNil(recommendation.discontinuedRuleSequence),
      areTargetFaresDiscontinued: _.isNil(recommendationLadder.areTargetFaresDiscontinued) ? null : recommendationLadder.areTargetFaresDiscontinued,
      hostCarrier: recommendation.carrier
    };
    populateKeyForCompetitor(recommendationLadder);
    var compEntry = getCompetitors(recommendation, recommendationLadder);
    var result = _.extend(newEntry, compEntry);
    dataUtilsService.assignGridDisplayFields(result);
    dataUtilsService.assignCustomClasses(result);
    return result;
  }
  function buildEntryAdaptive(recommendation, recommendationLadder, isFound, index) {
    var fareChangePercent = !_.isNil(recommendation.fareChange) && recommendation.fareChange === 0 ? 0 : null;
    if (!_.isNil(recommendation.fareChange) && recommendation.fareChange !== 0) {
      fareChangePercent = recommendation.fareChange / recommendation.currentFareAmount;
    }
    var recommendationActionCodes = dataUtilsService.getAdaptiveRecommendationActionCodes(recommendationLadder);
    var inboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(recommendation.inboundDaysOfWeek);
    var daysOfWeek = dataUtilsService.convertDayOfWeekNumber(recommendation.outboundDaysOfWeek);
    var season = getSeasonData(recommendationLadder, recommendation);
    var isLinkedFbc = recommendation.sponsorMarketFbc !== undefined;
    var isDualRbdFare = recommendation.dualRbdSponsorFbc !== undefined;
    var isEntryLevel = false;
    var groupingStartRow = false;
    var type = recommendationLadder.offerFareList[0].filedFareAmount !== undefined ? faresOptimizerConstants.LADDER_TYPE.OFFER_TRANSLATION : faresOptimizerConstants.LADDER_TYPE.ADAPTIVE;
    if (!isFound.entryLevel) {
      isEntryLevel = recommendationLadder.fareBasisCode === recommendation.fareBasisCode && !isLinkedFbc;
      isFound.entryLevel = isEntryLevel;
    }
    if (!isFound.startRow) {
      groupingStartRow = _.first(recommendationLadder.offerFareList).fareBasisCode === recommendation.fareBasisCode && !isLinkedFbc;
      isFound.startRow = groupingStartRow;
    }
    var stopAutoApprovalReasonsPresent = Object.keys(recommendationLadder.stopAutoApprovalReasons).length > 0;
    var ladderRemarks = buildAdaptiveLadderRemarks(recommendationLadder);
    var hasLinkedFbc = isLinkedFbc ? false : dataUtilsService.isSponsorMarketFbcForAdaptive(recommendationLadder, recommendation);
    var fareBrandInfo = dataUtilsService.getFareBrandInfo(recommendation.carrier, recommendation.offerFareBrand);
    updateDatesFromUserAdjustments(recommendation, recommendationLadder);
    var newEntry = {
      market: getMarket(recommendationLadder),
      origin: recommendationLadder.origin,
      destination: recommendationLadder.destination,
      cabin: recommendationLadder.cabinCode,
      carrier: recommendationLadder.carrier,
      footnote: recommendation.footnote,
      tariffCode: recommendation.tariffCode,
      tariffNumber: recommendation.tariffCode,
      fareBasisCode: recommendation.fareBasisCode,
      filedFareFbc: recommendation.filedFareFbc,
      offerFbc: recommendation.offerFbc,
      type: type,
      tripTypeCode: recommendation.tripTypeCd,
      routingNumber: recommendation.routingNumber,
      season: replaceNullOrHyphenValue(season),
      pos: recommendationLadder.pos,
      seasons: recommendation.seasons,
      marketTier: recommendationLadder.marketTier,
      filedTotalFareAmount: recommendation.filedTotalFareAmount,
      filedFareAmount: recommendation.filedFareAmount,
      dow: daysOfWeek,
      inboundDow: inboundDaysOfWeek,
      journeyTypeCd: recommendation.journeyTypeCd,
      rbd: recommendation.rbd,
      fbc: getResolvedFbc(isLinkedFbc, isDualRbdFare, recommendation, recommendationLadder),
      isEntryLevel: isEntryLevel,
      groupingStartRow: groupingStartRow,
      hasLinkedFbc: hasLinkedFbc,
      isLinkedFbc: isLinkedFbc,
      isDualRbdFare: isDualRbdFare,
      apGroup: replaceNullOrHyphenValue(recommendation.advancePurchaseReservation).toString(),
      mmsGroup: [replaceNullOrHyphenValue(recommendation.minStay), replaceNullOrHyphenValue(recommendation.maxStay)].join('/'),
      minStayGroup: replaceNullOrHyphenValue(recommendation.minStay).toString(),
      maxStayGroup: replaceNullOrHyphenValue(recommendation.maxStay).toString(),
      eventTimeStamp: recommendationLadder.eventTimeStamp,
      approvalDateTime: recommendationLadder.approvalDateTime,
      lastUpdated: convertToLocalDateTime(recommendationLadder.eventTimeStamp),
      isExpired: false,
      createdAt: recommendationLadder.createdAt,
      lastUpdatedBy: recommendationLadder.lastUpdatedBy,
      effectiveDate: momentService.of(recommendation.effectiveDate, momentService.FIELD.DEPARTURE_DATE),
      discontinueDate: momentService.of(recommendation.discontinueDate, momentService.FIELD.DEPARTURE_DATE),
      outboundSeasons: recommendation.journeyTypeCd === 'OB' ? recommendation.seasons : [],
      outboundBlackouts: recommendation.journeyTypeCd === 'IB' ? getResolvedAdaptiveBlackouts() : [],
      inboundSeasons: recommendation.journeyTypeCd === 'IB' ? recommendation.seasons : [],
      inboundBlackouts: recommendation.journeyTypeCd === 'OB' ? getResolvedAdaptiveBlackouts() : [],
      reservationDates: recommendation.reservationDates,
      ticketingDates: recommendation.ticketingDates,
      inboundTravelDates: recommendation.inboundTravelDates,
      outboundTravelDates: recommendation.outboundTravelDates,
      travelFromDate: momentService.of(recommendation.travelFromDate, momentService.FIELD.DEPARTURE_DATE),
      travelToDate: momentService.of(recommendation.travelToDate, momentService.FIELD.DEPARTURE_DATE),
      travelCompleteDate: momentService.of(recommendation.travelCompleteDate, momentService.FIELD.DEPARTURE_DATE),
      firstTicketDate: momentService.of(recommendation.firstTicketDate, momentService.FIELD.DEPARTURE_DATE),
      lastTicketDate: momentService.of(recommendation.lastTicketDate, momentService.FIELD.DEPARTURE_DATE),
      matchPercentage: recommendation.matchPercentage === undefined ? 0 : recommendation.matchPercentage,
      constructionMethod: recommendation.constructionMethod,
      minStay: recommendation.minStay,
      maxStay: recommendation.maxStay,
      advancePurchase: recommendation.advancePurchaseReservation,
      category: recommendationLadder.category,
      ap: replaceNullOrHyphenValue(recommendation.advancePurchase),
      mms: replaceNullOrHyphenValue(recommendation.minStay) + ' - ' + replaceNullOrHyphenValue(recommendation.maxStay),
      currencyCode: recommendation.currencyCd,
      currentFareTotal: recommendation.currentTotalFareAmount,
      recommendedFareTotal: recommendation.upsellTotalFareAmount,
      currentFareBase: recommendation.currentFareAmount,
      currentTotalFare: recommendation.currentTotalFareAmount,
      recommendedFareBase: recommendation.upsellFareAmount,
      effectiveBaseFare: recommendation.upsellFareAmount,
      distributedFare: recommendation.distributedFare,
      effectiveTotalFare: recommendation.upsellTotalFareAmount,
      fareChangeAbsolute: recommendation.fareChange,
      fareChangePercentage: fareChangePercent,
      effectiveFareChangeAbsolute: recommendation.effectiveFareChange,
      status: recommendationLadder.status,
      remarks: recommendationLadder.remarks,
      fareFamily: recommendation.fareBasisCode.substring(1),
      fareLadderRecordKey: recommendationLadder.fareLadderRecordKey,
      yq: recommendation.yq,
      yr: recommendation.yr,
      q: recommendation.q,
      airportTax: recommendation.other,
      variable: recommendation.variable,
      recommendedVariable: computeVariableTaxUsingBaseFare(recommendation.yq, recommendation.yr, recommendation.recommendedBaseFare, recommendation.variableTaxPercentage),
      effectiveVariable: recommendation.recommendedVariable,
      variableTaxPercentage: recommendation.variableTaxPercentage,
      qMisc: recommendation.qmisc,
      authorizationNotes: recommendationLadder.authorizationNotes,
      minFareThreshold: recommendation.minFareThreshold,
      maxFareThreshold: recommendation.maxFareThreshold,
      benchmarkFareComponent: recommendation.benchmarkFareComponent,
      recommendationEffectiveDate: momentService.of(recommendationLadder.recommendationEffectiveDate, momentService.FIELD.DEPARTURE_DATE),
      sponsorMarketFbc: recommendation.sponsorMarketFbc,
      dualRbdSponsorFbc: recommendation.dualRbdSponsorFbc,
      percentageLinkageFactor: recommendation.percentageLinkageFactor,
      useForLadderGenerationInd: _.isNil(recommendation.useForLadderGenerationInd) ? null : recommendation.useForLadderGenerationInd,
      absoluteLinkageFactor: recommendation.absoluteLinkageFactor,
      isSharedFbc: isSharedFbc(recommendation),
      sharedEntryLevelFbcList: extractSharedFbcList(recommendation),
      sharedFbcLadderIds: getSharedFBCLadderIds(recommendation),
      linkedFbcs: hasLinkedFbc ? dataUtilsService.getLinkedFbc(recommendationLadder, recommendation) : [],
      rejectionExpiryDateTime: recommendationLadder.rejectionExpiryDateTime,
      tripType: recommendation.tripTypeCd,
      fareBrand: fareBrandInfo.fareBrand,
      offerFareBrand: recommendation.offerFareBrand,
      journeyTotalFareAmount: recommendation.journeyTotalFareAmount,
      journeyAmount: recommendation.journeyAmount,
      fareBrandName: recommendation.normalizedFareBrand,
      actionCode: recommendation.actionCode,
      recommendationActionCodes: recommendationActionCodes,
      selectedCompetitorKey: recommendation.selectedCompetitorKey,
      isMappedRbd: !!(recommendation.selectedCompetitorKey && recommendation.actionCode !== 'X'),
      userAdjustedDates: recommendation.userAdjustedDates,
      businessRule: getBusinessRule(recommendationLadder.businessRule, recommendation.businessRule, isEntryLevel),
      seasonIndicator: recommendationLadder.seasonIndicator,
      hostEntryLevelFbc: recommendationLadder.fareBasisCode,
      hostHighestFbc: recommendationLadder.hostHighestFbc,
      ladderRemarks: ladderRemarks,
      autoApprovalStoppedReasonsFilterKeys: getAutoApprovalStoppedMessageDetails(ladderRemarks),
      isShowRecommendationId: true,
      isFootnoteUpdated: recommendationLadder.isFootnoteUpdated,
      isAutoApprovable: !stopAutoApprovalReasonsPresent,
      isRecommendationCapped: false,
      areTargetFaresDiscontinued: _.isNil(recommendationLadder.areTargetFaresDiscontinued) ? null : recommendationLadder.areTargetFaresDiscontinued,
      hostCarrier: recommendation.carrier
    };
    populateKeyForCompetitor(recommendationLadder);
    var filedFareTaxes = getFiledFareTaxes(recommendation);
    var offerTaxes = getOfferTaxes(recommendation, recommendationLadder);
    var currentFareTaxes = getCurrentFareTaxes(recommendation);
    var result = _.extend(newEntry, filedFareTaxes, offerTaxes, currentFareTaxes);
    dataUtilsService.assignGridDisplayFields(result);
    dataUtilsService.assignCustomClasses(result);
    return result;
  }
  function getResolvedAdaptiveBlackouts() {
    var currentYear = momentService.now(momentService.TYPE.LOCAL_DATE).year();
    var nextYear = currentYear + 1;
    return [{
      begin: "".concat(currentYear, "-01-01"),
      end: "".concat(nextYear, "-12-31")
    }];
  }
  function buildAdaptiveLadderRemarks(recommendationLadder) {
    return {
      noRecommendationReasons: recommendationLadder.noRecommendationReasons,
      recommendationReasons: recommendationLadder.recommendationReasons,
      filingUploadErrorReasons: recommendationLadder.filingUploadErrorReasons,
      dataComparisonReasons: [{
        dataComparisonDetailedRemarks: getAdaptiveStopAutoApprovalReasons(recommendationLadder.stopAutoApprovalReasons)
      }]
    };
  }
  function getResolvedFbc(isLinkedFbc, isDualRbdFare, recommendation, ladder) {
    if (isLinkedFbc) {
      return getLinkedRecommendationFBC(recommendation, ladder);
    }
    if (isDualRbdFare) {
      var sponsorRecommendation = _.find(ladder.fareRecommendationList, function (fare) {
        if (recommendation.dualRbdSponsorFbc.includes(fare.fareBasisCode) && fare.origin === recommendation.origin && fare.destination === recommendation.destination) return recommendation;
      });
      if (sponsorRecommendation.sponsorMarketFbc !== undefined) {
        return getLinkedRecommendationFBC(recommendation, ladder);
      }
    }
    return recommendation.fareBasisCode;
  }
  function getLinkedRecommendationFBC(recommendation, ladder) {
    if (hasDifferentCarrier(recommendation.carrier, ladder.carrier)) {
      return recommendation.fareBasisCode + ' (' + getCarrierMarket(recommendation) + ')';
    }
    return recommendation.fareBasisCode + ' (' + getMarket(recommendation) + ')';
  }
  function getMarket(recommendation) {
    return recommendation.origin + '-' + recommendation.destination;
  }
  function getCarrierMarket(recommendation) {
    return [recommendation.carrier, recommendation.origin, recommendation.destination].join('-');
  }
  function hasDifferentCarrier(recommendationCarrier, ladderCarrier) {
    return recommendationCarrier !== ladderCarrier;
  }
  function getSeasonData(recommendationLadder, recommendation) {
    var fbc = recommendation.fareBasisCode;
    if (recommendationLadder.category === faresOptimizerConstants.CATEGORY.TACTICAL) {
      fbc = recommendationLadder.hostHighestFbc;
      if (fbc === undefined) {
        return faresOptimizerConstants.EN_DASH;
      }
    }
    return dataUtilsService.getSeasonDefinition(recommendationLadder.seasonIndicator, fbc);
  }
  function computeVariableTaxUsingBaseFare(yq, yr, baseFare, variableTaxPercentage) {
    yq = checkNull(yq);
    yr = checkNull(yr);
    var varTaxPercentage = checkNull(variableTaxPercentage) / 100;
    baseFare = checkNull(baseFare);
    return varTaxPercentage * (baseFare + yq + yr);
  }
  function checkNull(value) {
    return _.isNil(value) ? 0 : value;
  }
  function isSharedFbc(recommendation) {
    return recommendation.sharedFBCList !== undefined && recommendation.sharedFBCList.length > 0;
  }
  function getSharedFBCLadderIds(recommendation) {
    if (isSharedFbc(recommendation)) {
      return _.map(recommendation.sharedFBCList, 'ladderID');
    }
    return [];
  }
  function isNotUpperBound(fbc, highestRecomFbc) {
    return !_.isEqual(fbc, highestRecomFbc);
  }
  function extractSharedFbcList(recommendation) {
    if (isSharedFbc(recommendation)) {
      return _.map(recommendation.sharedFBCList, 'ladderEntryLevelFBC');
    }
    return [];
  }
  function getBusinessRule(ladderBusinessRule, recommendationBusinessRule, isEntryLevel) {
    if (isEntryLevel) {
      return _.isEmpty(ladderBusinessRule) ? recommendationBusinessRule : ladderBusinessRule;
    }
    return recommendationBusinessRule || '';
  }
  function convertToLocalDateTime(eventTimeStamp) {
    if (_.isNil(eventTimeStamp)) {
      return undefined;
    }
    return momentService.of(eventTimeStamp, momentService.getConfig('DATE_TIME'), momentService.getFormat('DATE_TIME_MILLISECONDS_ISO'), undefined, false).value.format(momentService.getFormat('DATE_TIME_USER_SETTINGS'));
  }
  function initGroupEntry(entryRow, recommendationRows) {
    var initialGroupEntry = _.omit(entryRow, ['isEntryLevel', 'advancePurchase', 'customRowClasses', 'customCellClasses']);
    initialGroupEntry.groupedRows = recommendationRows;
    initialGroupEntry.isCollapsed = true;
    initialGroupEntry.maxFareChange = 0;
    initialGroupEntry.isSharedFbc = entryRow.isSharedFbc;
    initialGroupEntry.hasSharedFbc = false;
    initialGroupEntry.allSharedEntryLevelFbcList = [];
    initialGroupEntry.allSharedFbcLadderIds = [];
    entryRow.allSharedEntryLevelFbcList = [];
    var groupEntry = _.reduce(recommendationRows, function (result, row) {
      var maxChangeAbsolute = Math.abs(result.maxFareChange);
      result.maxFareChange = Math.abs(row.fareChangePercentage) > maxChangeAbsolute ? Math.abs(row.fareChangePercentage) : maxChangeAbsolute;
      result.hasSharedFbc = result.hasSharedFbc || row.isSharedFbc;
      if (pickNewPendingLadder(row)) {
        result.allSharedEntryLevelFbcList.push(row.sharedEntryLevelFbcList);
        result.allSharedFbcLadderIds.push(row.sharedFbcLadderIds);
      }
      entryRow.allSharedEntryLevelFbcList.push(row.sharedEntryLevelFbcList);
      if (!entryRow.isRecommendationCapped) {
        entryRow.isRecommendationCapped = row.status === faresOptimizerConstants.NEW && row.isRecommendationCapped;
      }
      return result;
    }, initialGroupEntry);
    entryRow.allSharedEntryLevelFbcList = removeEmptyArrays(entryRow.allSharedEntryLevelFbcList);
    entryRow.hasSharedFbc = groupEntry.hasSharedFbc;
    var lowestRbdRow = _.find(recommendationRows, {
      groupingStartRow: true
    });
    lowestRbdRow.fareCountNew = _.sumBy(recommendationRows, function (row) {
      return row.actionCode === 'N' ? 1 : 0;
    });
    if (entryRow.category === 'TACTICAL' && lowestRbdRow.fareCountNew > 0 && recommendationRows[recommendationRows.length - 1].actionCode === 'N') {
      lowestRbdRow.fareCountNew = lowestRbdRow.fareCountNew - 1;
    }
    lowestRbdRow.fareCountCanceled = _.sumBy(recommendationRows, function (row) {
      return row.actionCode === 'X' ? 1 : 0;
    });
    lowestRbdRow.fareCountChanged = _.sumBy(recommendationRows, function (row) {
      return row.actionCode === 'C' && row.fareChangeAbsolute ? 1 : 0;
    });
    groupEntry.allSharedEntryLevelFbcList = removeEmptyArrays(groupEntry.allSharedEntryLevelFbcList);
    groupEntry.allSharedFbcLadderIds = removeEmptyArrays(groupEntry.allSharedFbcLadderIds);
    var recommendationCountWithoutHighestFbc = recommendationRows.length - 1;
    groupEntry.allFaresCancelled = lowestRbdRow.fareCountCanceled >= recommendationCountWithoutHighestFbc && groupEntry.isSystemGeneratedLadder !== true;
    groupEntry.hasTargetFaresDiscontinued = groupEntry.areTargetFaresDiscontinued;
    return groupEntry;
  }
  function initGroupEntryAdaptive(entryRow, recommendationRows) {
    var initialGroupEntry = _.omit(entryRow, ['isEntryLevel', 'minStay', 'maxStay', 'advancePurchase', 'customRowClasses', 'customCellClasses']);
    initialGroupEntry.groupedRows = recommendationRows;
    initialGroupEntry.isCollapsed = true;
    initialGroupEntry.maxFareChange = 0;
    initialGroupEntry.isSharedFbc = entryRow.isSharedFbc;
    initialGroupEntry.hasSharedFbc = false;
    initialGroupEntry.allSharedEntryLevelFbcList = [];
    initialGroupEntry.allSharedFbcLadderIds = [];
    entryRow.allSharedEntryLevelFbcList = [];
    var groupEntry = _.reduce(recommendationRows, function (result, row) {
      var maxChangeAbsolute = Math.abs(result.maxFareChange);
      result.maxFareChange = Math.abs(row.fareChangePercentage) > maxChangeAbsolute ? Math.abs(row.fareChangePercentage) : maxChangeAbsolute;
      result.hasSharedFbc = result.hasSharedFbc || row.isSharedFbc;
      if (pickNewPendingLadder(row)) {
        result.allSharedEntryLevelFbcList.push(row.sharedEntryLevelFbcList);
        result.allSharedFbcLadderIds.push(row.sharedFbcLadderIds);
      }
      entryRow.allSharedEntryLevelFbcList.push(row.sharedEntryLevelFbcList);
      if (!entryRow.isRecommendationCapped) {
        entryRow.isRecommendationCapped = row.status === faresOptimizerConstants.NEW && row.isRecommendationCapped;
      }
      return result;
    }, initialGroupEntry);
    entryRow.allSharedEntryLevelFbcList = removeEmptyArrays(entryRow.allSharedEntryLevelFbcList);
    entryRow.hasSharedFbc = groupEntry.hasSharedFbc;
    var lowestRbdRow = _.find(recommendationRows, {
      groupingStartRow: true
    });
    lowestRbdRow.fareCountNew = _.sumBy(recommendationRows, function (row) {
      return row.actionCode === 'N' ? 1 : 0;
    });
    lowestRbdRow.fareCountCanceled = _.sumBy(recommendationRows, function (row) {
      return row.actionCode === 'X' ? 1 : 0;
    });
    lowestRbdRow.fareCountChanged = _.sumBy(recommendationRows, function (row) {
      return row.actionCode === 'C' && row.fareChangeAbsolute ? 1 : 0;
    });
    groupEntry.allSharedEntryLevelFbcList = removeEmptyArrays(groupEntry.allSharedEntryLevelFbcList);
    groupEntry.allSharedFbcLadderIds = removeEmptyArrays(groupEntry.allSharedFbcLadderIds);
    var recommendationCountWithoutHighestFbc = recommendationRows.length - 1;
    groupEntry.allFaresCancelled = lowestRbdRow.fareCountCanceled >= recommendationCountWithoutHighestFbc && groupEntry.isSystemGeneratedLadder !== true;
    groupEntry.hasTargetFaresDiscontinued = groupEntry.areTargetFaresDiscontinued;
    return groupEntry;
  }
  function removeEmptyArrays(data) {
    return _.chain(data).reject(_.isEmpty).flatten().uniq().value();
  }
  function pickNewPendingLadder(row) {
    return row.status === 'New' || row.status === 'Pending' || row.status === 'Approved';
  }
  function createRecommendationGroup(recommendationLadder) {
    var isFound = {
      entryLevel: false,
      startRow: false
    };
    var recommendationRows = _.reduce(recommendationLadder.fareRecommendationList, function (result, recommendation, index) {
      result.push(buildEntry(recommendation, recommendationLadder, isFound, index));
      return result;
    }, []);
    var entryRow = _.find(recommendationRows, {
      isEntryLevel: true
    });
    return initGroupEntry(entryRow, recommendationRows);
  }
  function createRecommendationAdaptiveGroup(recommendationLadder) {
    var isFound = {
      entryLevel: false,
      startRow: false
    };
    var recommendationRows = _.reduce(recommendationLadder.offerFareList, function (result, recommendation, index) {
      result.push(buildEntryAdaptive(recommendation, recommendationLadder, isFound, index));
      return result;
    }, []);
    var entryRow = _.find(recommendationRows, {
      isEntryLevel: true
    });
    return initGroupEntryAdaptive(entryRow, recommendationRows);
  }
  function createDetailsProperties(recommendationLadder, market, setOfAllSelectedCompetitorKeys) {
    var entryLevelHostRbd;
    var selectedCompetitor;
    var minFare = selectedComparisonDataTransformerService.findLowestRbdFare(recommendationLadder);
    selectedComparisonDataTransformerService.setIsSelectedToCompetitorMappedToLowestFareRbd(recommendationLadder, minFare);
    entryLevelHostRbd = _.find(recommendationLadder.fareRecommendationList, function (recommendation) {
      if (recommendation.baseFare === minFare) return recommendation;
    });
    if (_.isNil(entryLevelHostRbd)) {
      entryLevelHostRbd = _.find(recommendationLadder.fareRecommendationList, {
        'fareBasisCode': recommendationLadder.hostEntryLevelFbc
      });
      entryLevelHostRbd.selected = true;
    }
    selectedCompetitor = getSelectedBenchmarkedCompetitor(recommendationLadder);
    var selectedCompetitorSeasonIndicator = selectedCompetitor === undefined ? undefined : selectedCompetitor.seasonIndicator;
    var filteredCompetitors = _.filter(recommendationLadder.competitorFares, function (competitorFare) {
      return !_.isNil(selectedCompetitor) && competitorFare.carrier !== selectedCompetitor.carrier || _.isNil(selectedCompetitor) && !_.isNil(competitorFare.matchPercentage);
    });
    var sortedCompetitors = _.sortBy(filteredCompetitors, ['matchPercentage']).reverse();
    var competitorDataByCarrier = _.values(_.groupBy(sortedCompetitors, 'carrier'));
    var competitorCarrierData = [];
    for (var i = 0; i < competitorDataByCarrier.length; i++) {
      if (competitorDataByCarrier[i] !== undefined) {
        competitorCarrierData[i] = competitorDataByCarrier[i][0];
      }
    }
    var detailProperties = {
      entryLevelBenchmark: entryLevelBenchmarkDataTransformerService.buildEntryLevelBenchmarkData(recommendationLadder, market, setOfAllSelectedCompetitorKeys),
      selectedComparison: selectedComparisonDataTransformerService.buildSelectedComparisonData(recommendationLadder),
      entryLevelFbcData: buildApplicableDatesChartData(entryLevelHostRbd, recommendationLadder.seasonIndicator, market),
      selectedCompetitorData: buildApplicableDatesChartData(selectedCompetitor, selectedCompetitorSeasonIndicator, market)
    };
    return recommendationLadder.category === faresOptimizerConstants.CATEGORY.STRUCTURAL ? getStructuralCompetitorData(detailProperties, competitorCarrierData, selectedCompetitor) : getTacticalCompetitorData(detailProperties, competitorCarrierData, selectedCompetitor);
  }
  function createDetailsPropertiesAdaptive(recommendationLadder, market, setOfAllSelectedCompetitorKeys) {
    var entryLevelHostRbd;
    var selectedCompetitor;
    var minFare = selectedComparisonDataTransformerService.findLowestRbdFare(recommendationLadder);
    selectedComparisonDataTransformerService.setIsSelectedToCompetitorMappedToLowestFareRbd(recommendationLadder, minFare);
    entryLevelHostRbd = _.find(recommendationLadder.offerFareList, function (recommendation) {
      if (recommendation.baseFare === minFare) return recommendation;
    });
    if (_.isNil(entryLevelHostRbd)) {
      entryLevelHostRbd = _.find(recommendationLadder.offerFareList, {
        'fareBasisCode': recommendationLadder.fareBasisCode
      });
      entryLevelHostRbd.selected = true;
    }
    selectedCompetitor = getSelectedBenchmarkedCompetitor(recommendationLadder);
    var selectedCompetitorSeasonIndicator = selectedCompetitor === undefined ? undefined : selectedCompetitor.seasonIndicator;
    var filteredCompetitors = _.filter(recommendationLadder.competitorFares, function (competitorFare) {
      return !_.isNil(selectedCompetitor) && competitorFare.carrier !== selectedCompetitor.carrier || _.isNil(selectedCompetitor);
    });
    var sortedCompetitors = _.sortBy(filteredCompetitors, ['matchPercentage']).reverse();
    var competitorDataByCarrier = _.values(_.groupBy(sortedCompetitors, 'carrier'));
    var competitorCarrierData = [];
    for (var i = 0; i < competitorDataByCarrier.length; i++) {
      if (competitorDataByCarrier[i] !== undefined) {
        competitorCarrierData[i] = competitorDataByCarrier[i][0];
      }
    }
    var detailProperties = {
      entryLevelBenchmark: entryLevelBenchmarkDataTransformerService.buildEntryLevelBenchmarkData(recommendationLadder, market, setOfAllSelectedCompetitorKeys),
      selectedComparison: selectedComparisonDataTransformerService.buildSelectedComparisonData1(recommendationLadder),
      entryLevelFbcData: buildApplicableDatesChartData(entryLevelHostRbd, recommendationLadder.seasonIndicator, market),
      selectedCompetitorData: buildApplicableDatesChartData(selectedCompetitor, selectedCompetitorSeasonIndicator, market)
    };
    return recommendationLadder.category === faresOptimizerConstants.CATEGORY.STRUCTURAL || recommendationLadder.category === faresOptimizerConstants.CATEGORY.ADAPTIVE ? getStructuralCompetitorData(detailProperties, competitorCarrierData, selectedCompetitor) : getTacticalCompetitorData(detailProperties, competitorCarrierData, selectedCompetitor);
  }
  function getSelectedBenchmarkedCompetitor(recommendationLadder) {
    return _.find(recommendationLadder.competitorFares, function (compFare) {
      if (compFare.competitorKey !== undefined && compFare.toBeSelected === true && compFare.hostRbd.includes(recommendationLadder.hostEntryLevelFbc.substring(0, 1))) {
        return compFare;
      }
    });
  }
  function getStructuralCompetitorData(detailProperties, competitorCarrierData, selectedCompetitor) {
    return Object.assign(detailProperties, {
      competitorData1: selectedCompetitor === undefined ? buildApplicableDatesChartData(competitorCarrierData[0]) : buildApplicableDatesChartData(selectedCompetitor),
      competitorData2: selectedCompetitor === undefined ? buildApplicableDatesChartData(competitorCarrierData[1]) : buildApplicableDatesChartData(competitorCarrierData[0]),
      competitorData3: selectedCompetitor === undefined ? buildApplicableDatesChartData(competitorCarrierData[2]) : buildApplicableDatesChartData(competitorCarrierData[1])
    });
  }
  function getTacticalCompetitorData(detailProperties, competitorCarrierData, selectedCompetitor) {
    var competitorsData = _.chain(competitorCarrierData).thru(function (competitorData) {
      if (!_.isUndefined(selectedCompetitor)) {
        competitorData.unshift(selectedCompetitor);
      }
      return competitorData;
    }).value();
    detailProperties.competitorsData = _.map(competitorsData, function (competitorData) {
      return buildApplicableDatesChartData(competitorData);
    });
    return detailProperties;
  }
  function transformRecommendationLadder(data) {
    var setOfAllSelectedCompetitorKeys = new Set();
    var ladderList = _.reduce(data.foRecommendationLadderList, function (resultLadderList, recommendationLadder) {
      var ladder = createRecommendationGroup(recommendationLadder);
      if (ladder.category === 'TACTICAL') {
        setOfAllSelectedCompetitorKeys.add(_.find(ladder.groupedRows, {
          isEntryLevel: true
        }).selectedCompetitorKey);
      }
      resultLadderList.push(ladder);
      return resultLadderList;
    }, []);
    var i = 0;
    return _.reduce(data.foRecommendationLadderList, function (resultLadderList, recommendationLadder) {
      resultLadderList.push(buildRecommendationLadderData(recommendationLadder, ladderList[i], setOfAllSelectedCompetitorKeys));
      i++;
      return resultLadderList;
    }, []);
  }
  function transformRecommendationLadderAdaptive(data) {
    var setOfAllSelectedCompetitorKeys = new Set();
    var ladderList = _.reduce(data.offerBasedFareLadderList, function (resultLadderList, recommendationLadder) {
      var ladder = createRecommendationAdaptiveGroup(recommendationLadder);
      resultLadderList.push(ladder);
      return resultLadderList;
    }, []);
    var i = 0;
    return _.reduce(data.offerBasedFareLadderList, function (resultLadderList, recommendationLadder) {
      resultLadderList.push(buildRecommendationLadderDataAdaptive(recommendationLadder, ladderList[i], setOfAllSelectedCompetitorKeys));
      i++;
      return resultLadderList;
    }, []);
  }
  function transformCompetitorLadder(data) {
    return _.reduce(data.foCompetitorFareLadderList, function (competitorResultList, competitorLadder) {
      competitorResultList.push(buildCompetitorLadderData(competitorLadder));
      return competitorResultList;
    }, []);
  }
  function transformWebFares(data) {
    return _.reduce(data.webFareCurveList, function (webFareResultList, webFareCurve) {
      webFareResultList.push(buildWebEntryLevelBenchmarkData(webFareCurve.webFares));
      return webFareResultList;
    }, []);
  }
  function transformAuditLog(data) {
    return _.reduce(data.failureAuditLog, function (resultAuditLogList, auditLog) {
      resultAuditLogList.push(buildFailureAuditLogData(auditLog));
      return resultAuditLogList;
    }, []);
  }
  function buildFailureAuditLogData(auditLog) {
    var detailKeys = Object.keys(auditLog.properties || {}).filter(function (key) {
      return key !== 'message';
    });
    return {
      carrier: auditLog.carrier,
      origin: auditLog.origin,
      destination: auditLog.destination,
      cabin: auditLog.cabin,
      category: auditLog.category,
      type: auditLog.type,
      message: auditLog.properties['message'],
      details: auditLog.properties,
      detailKeys: detailKeys,
      lastUpdatedAt: convertToLocalDateTime(auditLog.lastUpdatedAt)
    };
  }
  function buildRecommendationLadderData(data, ladder, setOfAllSelectedCompetitorKeys) {
    var details = createDetailsProperties(data, ladder.market, setOfAllSelectedCompetitorKeys);
    return _.extend(ladder, details);
  }
  function buildRecommendationLadderDataAdaptive(data, ladder, setOfAllSelectedCompetitorKeys) {
    var details = createDetailsPropertiesAdaptive(data, ladder.market, setOfAllSelectedCompetitorKeys);
    return _.extend(ladder, details);
  }
  function buildCompetitorLadderData(data) {
    return {
      hostRecommendationKeys: data.hostRecommendationKeys,
      competitorEntryLevelFbc: data.competitorEntryLevelFbc,
      competitorFareSource: data.fareSource,
      competitorHostCarrier: data.hostCarrier,
      competitorCarrier: data.carrier,
      competitorOrigin: data.origin,
      competitorDestination: data.destination,
      competitorTariffCode: data.tariffCode,
      competitorRoutingNumber: data.routingNumber,
      competitorFootnote: data.footnote,
      competitorLadder: data.competitorFareList,
      compBaseFare: data.compBaseFare,
      compVariable: data.compVariable,
      yq: data.yq,
      yr: data.yr,
      sixH: data.sixH,
      sixI: data.sixI,
      sixJ: data.sixJ,
      sixK: data.sixK,
      q: data.q,
      airportTax: data.airportTax,
      qMisc: data.qMisc,
      isShowRecommendationId: false
    };
  }
  function buildWebEntryLevelBenchmarkData(webFares, market) {
    return _.transform(webFares, function (entryLevelBenchmarkData, webFare) {
      entryLevelBenchmarkData.push(getWebFareData(webFare, market));
    }, []);
  }
  function getWebFareData(webFare, market) {
    return {
      market: market,
      carrier: webFare.carrier,
      compMarket: webFare.origin + '-' + webFare.destination,
      origin: webFare.origin,
      destination: webFare.destination,
      fareSource: faresOptimizerConstants.FARE_SOURCE.WEB_FARE,
      rbd: getRbd(webFare.rbdOutbound, webFare.rbdInbound),
      rbdOutbound: webFare.rbdOutbound,
      rbdInbound: webFare.rbdInbound,
      currencyCode: webFare.currency,
      baseFare: webFare.netFare,
      totalFare: webFare.totalFare,
      yq: webFare.yq,
      yr: webFare.yr,
      sixH: webFare.sixH,
      sixI: webFare.sixI,
      sixJ: webFare.sixJ,
      sixK: webFare.sixK,
      airportTax: webFare.other,
      departureDate: webFare.departureDate,
      returnDate: webFare.returnDate,
      tripType: faresOptimizerConstants.FARE_TYPES[webFare.fareType],
      connectionOutbound: webFare.connectionOutbound,
      lowestBaseFarePercentage: webFare.lowestBaseFarePercentage,
      lowestTotalFarePercentage: webFare.lowestTotalFarePercentage
    };
  }
  function getRbd(outboundRbd, inboundRbd) {
    if (!_.isNil(outboundRbd) && !_.isNil(inboundRbd)) {
      return outboundRbd + '(O)' + ', ' + inboundRbd + '(I)';
    }
    if (!_.isNil(outboundRbd)) {
      return outboundRbd + '(O)';
    }
    if (!_.isNil(inboundRbd)) {
      return inboundRbd + '(I)';
    }
    return undefined;
  }
  function buildApplicableDatesChartData(fareRecord, seasonIndicator, market) {
    if (fareRecord === undefined) {
      return {};
    }
    var outboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(fareRecord.outboundDaysOfWeek);
    var inboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(fareRecord.inboundDaysOfWeek);
    var fareBrandInfo = dataUtilsService.getFareBrandInfo(fareRecord.carrier, fareRecord.fareBrand);
    return {
      fareSource: fareRecord.fareSource,
      market: market,
      carrier: fareRecord.carrier,
      compMarket: fareRecord.origin + '-' + fareRecord.destination,
      origin: fareRecord.origin,
      destination: fareRecord.destination,
      cabin: fareRecord.cabinCode,
      category: fareRecord.category,
      fbc: fareRecord.fareBasisCode,
      tariffCode: fareRecord.tariffCode,
      routingNumber: fareRecord.routingNumber,
      footnote: fareRecord.footnote,
      season: replaceNullOrHyphenValue(dataUtilsService.getSeasonDefinition(seasonIndicator, fareRecord.fareBasisCode)),
      dow: outboundDaysOfWeek,
      inboundDow: inboundDaysOfWeek,
      constructionMethod: fareRecord.constructionMethod,
      ap: replaceNullOrHyphenValue(fareRecord.advancePurchase),
      minStays: fareRecord.minStays,
      maxStay: fareRecord.maxStay,
      mms: replaceNullOrHyphenValue(fareRecord.minStays) + ' - ' + replaceNullOrHyphenValue(fareRecord.maxStay),
      travelFromDate: fareRecord.travelFromDate,
      travelToDate: fareRecord.travelToDate,
      travelCompleteDate: fareRecord.travelCompleteDate,
      firstTicketDate: fareRecord.firstTicketDate,
      lastTicketDate: fareRecord.lastTicketDate,
      effectiveDate: fareRecord.effectiveDate,
      discontinueDate: fareRecord.discontinueDate,
      outboundSeasons: fareRecord.outboundSeasons,
      outboundBlackouts: fareRecord.outboundBlackouts,
      inboundSeasons: fareRecord.inboundSeasons,
      inboundBlackouts: fareRecord.inboundBlackouts,
      reservationDates: fareRecord.reservationDates,
      ticketingDates: fareRecord.ticketingDates,
      inboundTravelDates: fareRecord.inboundTravelDates,
      outboundTravelDates: fareRecord.outboundTravelDates,
      matchPercentage: fareRecord.matchPercentage === undefined ? 0 : fareRecord.matchPercentage,
      isRuleUpdated: fareRecord.isRuleUpdated,
      isFootnoteUpdated: fareRecord.isFootnoteUpdated,
      isSelected: fareRecord.isSelected,
      isActive: fareRecord.isActive,
      benchmarkFareComponent: fareRecord.benchmarkFareComponent,
      tripType: faresOptimizerConstants.FARE_TYPES[fareRecord.tripType],
      fareBrand: fareBrandInfo.fareBrand,
      fareBrandName: fareBrandInfo.fareBrandName,
      selectedCompetitorKey: fareRecord.selectedCompetitorKey
    };
  }
  function updateRecommendation(rawData, updatedRecommendationLadder, selectedHostLadderData, recommendMode) {
    var recommendationRecordKey = recommendMode !== 'ADAPTIVE' ? updatedRecommendationLadder.fareRecommendationRecordKey : updatedRecommendationLadder.fareLadderRecordKey;
    var match = recommendMode !== 'ADAPTIVE' ? _.find(rawData, {
      fareRecommendationRecordKey: recommendationRecordKey
    }) : _.find(rawData, {
      fareLadderRecordKey: recommendationRecordKey
    });
    if (updatedRecommendationLadder.category === faresOptimizerConstants.CATEGORY.TACTICAL) {
      match = _.find(rawData, {
        origin: updatedRecommendationLadder.origin,
        destination: updatedRecommendationLadder.destination,
        cabin: updatedRecommendationLadder.cabin,
        fareFamily: updatedRecommendationLadder.fareFamily,
        footnote: updatedRecommendationLadder.footnote,
        tariffCode: updatedRecommendationLadder.tariffCode,
        routingNumber: updatedRecommendationLadder.routingNumber
      });
    }
    if (match) {
      var index = _.indexOf(rawData, match);
      rawData.splice(index, 1, updatedRecommendationLadder);
    } else {
      rawData.push(updatedRecommendationLadder);
    }
    if (selectedHostLadderData !== undefined && selectedHostLadderData.data !== undefined && isSameLadder(updatedRecommendationLadder, selectedHostLadderData.data)) {
      selectedHostLadderData.data = updatedRecommendationLadder;
    }
  }
  function updateRecommendationInMarketChunks(marketChunk, updatedRecommendationLadder, selectedHostLadderData, recommendMode) {
    var recommendationRecordKey = recommendMode !== 'ADAPTIVE' ? updatedRecommendationLadder.fareRecommendationRecordKey : updatedRecommendationLadder.fareLadderRecordKey;
    var match = recommendMode !== 'ADAPTIVE' ? _.find(_.flatMap(marketChunk), {
      fareRecommendationRecordKey: recommendationRecordKey
    }) : _.find(_.flatMap(marketChunk), {
      fareLadderRecordKey: recommendationRecordKey
    });
    if (updatedRecommendationLadder.category === faresOptimizerConstants.CATEGORY.TACTICAL) {
      match = _.find(marketChunk, {
        origin: updatedRecommendationLadder.origin,
        destination: updatedRecommendationLadder.destination,
        cabin: updatedRecommendationLadder.cabin,
        fareFamily: updatedRecommendationLadder.fareFamily,
        footnote: updatedRecommendationLadder.footnote,
        tariffCode: updatedRecommendationLadder.tariffCode,
        routingNumber: updatedRecommendationLadder.routingNumber
      });
    }
    if (match) {
      _.forEach(marketChunk, function (chunk) {
        var index = _.indexOf(chunk, match);
        if (index >= 0) {
          chunk.splice(index, 1, updatedRecommendationLadder);
        }
      });
    } else {
      marketChunk.push(updatedRecommendationLadder);
    }
    if (selectedHostLadderData !== undefined && selectedHostLadderData.data !== undefined && isSameLadder(updatedRecommendationLadder, selectedHostLadderData.data)) {
      selectedHostLadderData.data = updatedRecommendationLadder;
    }
  }
  function isSameLadder(updatedRecommendationLadder, selectedHostLadderData) {
    if (updatedRecommendationLadder.category === faresOptimizerConstants.CATEGORY.TACTICAL) {
      return selectedHostLadderData.origin === updatedRecommendationLadder.origin && selectedHostLadderData.destination === updatedRecommendationLadder.destination && selectedHostLadderData.cabin === updatedRecommendationLadder.cabin && selectedHostLadderData.fareFamily === updatedRecommendationLadder.fareFamily && selectedHostLadderData.footnote === updatedRecommendationLadder.footnote && selectedHostLadderData.tariffCode === updatedRecommendationLadder.tariffCode && selectedHostLadderData.routingNumber === updatedRecommendationLadder.routingNumber;
    } else {
      return selectedHostLadderData.fareRecommendationRecordKey === updatedRecommendationLadder.fareRecommendationRecordKey;
    }
  }
  function isUserAdjustmentUndefined(recommendation) {
    return _.isUndefined(recommendation.userAdjustedDates) || _.isNil(recommendation.userAdjustedDates);
  }
  function isUserAdjustedDatesNullOrUndefined(recommendation, fieldName) {
    return _.isUndefined(recommendation.userAdjustedDates) || _.isNil(recommendation.userAdjustedDates) || _.isUndefined(recommendation.userAdjustedDates[fieldName]) || _.isNil(recommendation.userAdjustedDates[fieldName]);
  }
  function replaceNullOrHyphenValue(value) {
    return _.isNil(value) || value === '-' ? faresOptimizerConstants.EN_DASH : value;
  }
  function getMomentType(date) {
    return (0, _typeof2["default"])(date) === 'object' ? date : momentService.of(date, momentService.TYPE.LOCAL_DATE);
  }
  function isPreviousDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isBefore(date2);
    }
    return false;
  }
  function isAfterDate(date1, date2) {
    date1 = getMomentType(date1);
    date2 = getMomentType(date2);
    if (date1 && date2) {
      return date1.isAfter(date2);
    }
    return false;
  }
  function getEarliestDate(data, fieldName, dateFieldName) {
    var earliestDate;
    _.each(data.userAdjustedDates[fieldName], function (element) {
      if (!earliestDate || isPreviousDate(element[dateFieldName], earliestDate)) {
        earliestDate = element[dateFieldName];
      }
    });
    return earliestDate;
  }
  function getLatestDate(data, fieldName, dateFieldName) {
    var latestDate;
    _.each(data.userAdjustedDates[fieldName], function (element) {
      if (!latestDate || isAfterDate(element[dateFieldName], latestDate)) {
        latestDate = element[dateFieldName];
      }
    });
    return latestDate;
  }
  function getLadderMethod(recommendationLadder) {
    return recommendationLadder.ladderMethod;
  }
  function getAdaptiveStopAutoApprovalReasons(stopAutoApprovalRemarks) {
    return Object.entries(stopAutoApprovalRemarks).map(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return {
        shortMessage: key,
        detailedMessage: value
      };
    });
  }
  function getDataComparisonReasons(dataComparisonReasons, isPrefixMessageDate) {
    var reasonsDetails = [];
    if (_.isEmpty(dataComparisonReasons)) {
      return reasonsDetails;
    }
    _.forEach(dataComparisonReasons, function (dataComparisonReason) {
      var messageDate = dataComparisonReason.messageDate;
      _.forEach(dataComparisonReason.dataComparisonDetailedRemarks, function (dataComparisonDetailedRemark) {
        var shortMessage = dataComparisonDetailedRemark.shortMessage.replace(/_/g, ' ');
        var header = isPrefixMessageDate && !(_.isUndefined(dataComparisonReason.messageDate) || _.isNil(dataComparisonReason.messageDate)) ? messageDate + ' : ' + shortMessage : shortMessage;
        reasonsDetails.push({
          header: header,
          shortRemark: shortMessage,
          detailRemark: dataComparisonDetailedRemark.detailedMessage.split(/\.\s+/g)
        });
      });
    });
    return reasonsDetails;
  }
  function getRuleMissingLadderRemarks(remarks) {
    return _.chain(remarks).map(function (remark) {
      return remark.shortRemark;
    }).filter(function (shortRemark) {
      if (!_.isUndefined(shortRemark) && shortRemark.startsWith('Fare Basis Code Missing in ATPCO:')) {
        return true;
      }
    }).value();
  }
  function getCancelLadderRemarks(remarks) {
    return _.chain(remarks).filter(function (remark) {
      if (!_.isUndefined(remark.shortRemark) && remark.shortRemark.includes('Cancel Threshold breach')) {
        return true;
      }
    }).map(function (remark) {
      return remark.detailRemark;
    }).value();
  }
  return {
    createRecommendationGroup: createRecommendationGroup,
    buildRecommendationLadderData: buildRecommendationLadderData,
    transformRecommendationLadder: transformRecommendationLadder,
    transformRecommendationLadderAdaptive: transformRecommendationLadderAdaptive,
    updateRecommendation: updateRecommendation,
    transformCompetitorLadder: transformCompetitorLadder,
    transformWebFares: transformWebFares,
    transformAuditLog: transformAuditLog,
    updateRecommendationInMarketChunks: updateRecommendationInMarketChunks,
    getDataComparisonReasons: getDataComparisonReasons,
    getRuleMissingLadderRemarks: getRuleMissingLadderRemarks,
    getCancelLadderRemarks: getCancelLadderRemarks
  };
};
FaresOptimizerDataTransformerService.$inject = ['$q', '$filter', 'MomentService', 'Restangular', 'ConfigurationService', 'FaresOptimizerAnalysisDataUtilsService', 'FaresOptimizerConstants', 'EntryLevelBenchmarkDataTransformerService', 'SelectedComparisonDataTransformerService'];
module.exports = FaresOptimizerDataTransformerService;